import { render, staticRenderFns } from "./ScriptGroupKeyEditor.vue?vue&type=template&id=65848f2c&scoped=true&"
import script from "./ScriptGroupKeyEditor.vue?vue&type=script&lang=ts&"
export * from "./ScriptGroupKeyEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ScriptGroupKeyEditor.vue?vue&type=style&index=0&id=65848f2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65848f2c",
  null
  
)

export default component.exports